<template>
  <div>
    <b-button 
      variant="ghost" 
      class="text-danger" 
      @click="startDelete"
    >
      <font-awesome-icon icon="trash" /> {{ title }}
    </b-button>
    <b-modal 
      v-model="showDeleteConfirmation"
      :ok-disabled="!doublecheck"
      title="Bevestig verwijdering unit" 
      ok-variant="danger" 
      ok-title="Verwijder"
      @hide="doublecheck= false"

      @ok="$emit('confirmed')"
    >
      <b-check 
        v-model="doublecheck" 
        switch
      > 
        De unit zal worden verwijderd uit Transplan. Deze is na verwijdering niet meer te herstellen.
      </b-check>
    </b-modal>
  </div>
</template>
<script>
export default {
    name: 'DeleteButton',
    components: {},
    mixins: [],
    props: {
        title: {
            type: String,
            default: 'Verwijderen'
        }
    },
    data() {
        return  {
            showDeleteConfirmation: false,
            doublecheck: false
        }
    },
    computed: {},
    watch: {},
    mounted () {
        
    },
    methods: {
        startDelete() {
            this.showDeleteConfirmation = true;
        },
    },
          
}
</script>